import React from "react";
import Button from "../components/common/Button.tsx";
import AddressSearchbar from "../components/features/AddressSearchbar.tsx";
import { AddressSuggestion } from "../types";
import {
  setOrderType,
  setAddress,
  useTypedDispatch,
  useTypedSelector,
  useFetchCurrentOrdersCountQuery,
} from "../store/index.ts";
import OrderTypeDropDown from "../components/features/OrderTypeDropDown.tsx";
import { Link, useNavigate } from "react-router-dom";
import {
  DELIVERY_OPTIONS,
  HOME_FEATURES,
  REQUESTS,
  STORES,
} from "../configs/lists.config.tsx";
import StoreCard from "../components/features/StoreCard.tsx";
import RequestCard from "../components/features/RequestCard.tsx";
import FeatureCard from "../components/features/FeatureCard.tsx";

const Home: React.FC = () => {
  const { search } = useTypedSelector((state) => state.session);
  const isLoggedIn = useTypedSelector(
    (state) => state.session.user?.accessToken
  );
  const { address, orderType } = search;
  const { data: order } = useFetchCurrentOrdersCountQuery(undefined, {
    pollingInterval: 20000,
    skip: !isLoggedIn,
  });

  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const handleAddressSelection = (address: AddressSuggestion) => {
    dispatch(setAddress(address));
  };

  const handleOrdertypeSelection = (field: string, value: string) => {
    dispatch(setOrderType(value));
  };

  const renderedFeatures = HOME_FEATURES.map((feature, index) => (
    <FeatureCard
      key={index}
      text={feature.text}
      image={feature.image}
    />
  ));

  const renderedStores = STORES.map((store, index) => (
    <StoreCard
      key={index}
      title={store.title}
      imagePath={store.imagePath}
    />
  ));

  const renderedRequests = REQUESTS.map((request, index) => (
    <RequestCard
      key={index}
      title={request.title}
      btnTitle={request.btnTitle}
      imagePath={request.imagePath}
      redirectionPath={request.redirectionPath}
    />
  ));

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <div className="w-full flex items-center p-8">
        <h1 className="text-3xl md:text-6xl font-bold">
          {" "}
          Vos restaurants <span className="text-primary"> préférés </span>,{" "}
          <br /> livrés{" "}
          <span className="text-primary"> où que vous soyez. </span>{" "}
        </h1>
        <img
          src="/assets/images/home.png"
          className="ml-auto hidden md:block"
        />
      </div>
      <div className="w-full flex flex-col md:flex-row items-center gap-3 p-4">
        <div className="w-full md:w-3/5">
          <AddressSearchbar
            value={address}
            setAddress={handleAddressSelection}
            placeholder="Saisissez votre adresse"
            className="h-20"
          />
        </div>
        <div className="flex items-center gap-3 w-full md:w-2/5">
          <div className="w-1/2">
            <OrderTypeDropDown
              id={"orderType"}
              value={orderType}
              options={DELIVERY_OPTIONS}
              setFieldValue={handleOrdertypeSelection}
              className="shadow-lg min-h-20 text-lg w-full"
            />
          </div>

          <Button
            className="shadow-lg min-h-20 rounded p-1 w-1/2 bg-primary"
            disabled={!address}
          >
            <div
              className="w-full text-white font-semibold text-lg"
              onClick={() => {
                navigate("/restaurants");
              }}
            >
              Voir les restaurants
            </div>
          </Button>
        </div>
      </div>
      <div className="w-full mt-12 md:mt-32 justify-evenly flex flex-col md:flex-row items-center gap-3">
        {renderedFeatures}
      </div>
      <div className="w-full min-h-[360px] bg-gray-100 flex flex-col gap-8 items-center justify-center mt-20">
        <div className="text-lg font-semibold text-center">
          <span> Télécharger notre application mobile pour </span> <br />
          <span className="text-primary"> plus de fonctionnalités </span>
        </div>
        <div className="flex flex-col md:flex-row gap-3">{renderedStores}</div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 px-8 my-12">
        {renderedRequests}
      </div>
      <div className="h-20" />
      {order?.currentOrdersCount && (
        <Link
          className="fixed bottom-6 right-6 bg-primary text-white shadow-lg rounded-xl px-4 py-3 text-sm font-semibold z-50 animate-fadeIn cursor-pointer"
          to="/current-orders"
        >
          {order.currentOrdersCount} commande
          {order.currentOrdersCount > 1 ? "s" : ""} en cours
        </Link>
      )}
    </div>
  );
};

export default Home;
